<kendo-card class="modbus-card" >

  <kendo-card-header>

    <div> <kendo-icon name="home">  </kendo-icon> <small> &nbsp; &nbsp; Node {{  modbusTree.nodeid }}   </small></div>
    <h1 kendoCardTitle>
      <div [ngClass]="GetAlarmLevel()"> {{ modbusTree.description }}</div>
    </h1>
    <p kendoCardSubtitle> Device:  <B>  {{ modbusTree.device }}  </B>  {{ modbusTree.brandcode }} </p>
  </kendo-card-header>

  <kendo-card-body class="modbusnetwork-card-body">

    <kendo-arcgauge class="modbus-valve"  [value]="modbusTree.current" [scale]="{ max: 1000 }">
      <ng-template kendoArcGaugeCenterTemplate let-value="value">
        {{ value / 10 }}%
      </ng-template>
    </kendo-arcgauge>


  </kendo-card-body>
  <kendo-card-footer class="modbusnetwork-kendo-card-footer">
    <small>
      <table class="table_component">
        <tbody>
        <tr>
          <td> Node:</td>
          <td> {{ modbusTree.nodeerrorstr }}  ({{ modbusTree.nodeerror }})</td>
        </tr>
        <tr>
          <td> Actual:</td>
          <td> {{ modbusTree.current }}</td>
          <td>Sensor 1:</td>
          <td> {{ ConvertValue(modbusTree.sensor1_value, modbusTree.sensor1_type) }}</td>
        </tr>
        <tr>
          <td> Target:</td>
          <td>{{ modbusTree.target }}
          <td> Sensor 2:</td>
          <td> {{ ConvertValue(modbusTree.sensor2_value, modbusTree.sensor2_type) }}</td>
        </tr>
        <tr>
          <td> Alarm:</td>
          <td>{{ modbusTree.alarm }}</td>
          <td>Ref:</td>
          <td>{{ refNumber }}</td>
        </tr>
        </tbody>
      </table>
    </small>
  </kendo-card-footer>
</kendo-card>




